import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Filter } from '@api/user/types/Filter';
import { FullFilter } from '@api/user/types/FullFilter';
import { formatISO } from 'date-fns';
import { convertFullFilterToFilter } from '@pages/filter/store/convertors';
import { DateRange } from '@project-types/DateRange';



interface FilterState {
	filter: Filter,
	modifiedFilter: Filter,
};

export const initialState: FilterState = {
	filter: {
		dateFrom: formatISO(new Date()),
		dateTo: formatISO(new Date()),
		distributionTypes: [],
		orderTypes: [],
		countries: [],
		regions: [],
		distributionRegions: [],
		districts: [],
		distributionDistricts: [],
		executionPlaces: [],
		customerHierarchies: [],
		materialTypes: [],
		onOffTrade: [],
	},
	modifiedFilter: {
		dateFrom: formatISO(new Date()),
		dateTo: formatISO(new Date()),
		distributionTypes: [],
		orderTypes: [],
		countries: [],
		regions: [],
		distributionRegions: [],
		districts: [],
		distributionDistricts: [],
		executionPlaces: [],
		customerHierarchies: [],
		materialTypes: [],
		onOffTrade: [],
	},
};



export const filterSlice = createSlice({
	name: 'filter',
	initialState,
	reducers: {
		setFilter: (state, action: PayloadAction<Filter>) => {
			state.filter = action.payload;
			state.modifiedFilter = action.payload;
		},
		resetFilter: (state) => {
			state.modifiedFilter = state.filter;
		},
		clearFilter: (state) => {
			state.modifiedFilter = {
				...state.filter,
				distributionTypes: initialState.modifiedFilter.distributionTypes,
				orderTypes: initialState.modifiedFilter.orderTypes,
				countries: initialState.modifiedFilter.countries,
				regions: initialState.modifiedFilter.regions,
				distributionRegions: initialState.modifiedFilter.distributionRegions,
				districts: initialState.modifiedFilter.districts,
				distributionDistricts: initialState.modifiedFilter.distributionDistricts,
				executionPlaces: initialState.modifiedFilter.executionPlaces,
				customerHierarchies: initialState.modifiedFilter.customerHierarchies,
				materialTypes: initialState.modifiedFilter.materialTypes,
				onOffTrade: initialState.modifiedFilter.onOffTrade,
			};
		},
		fillFilter: (state, action: PayloadAction<FullFilter>) => {
			let convertedFilter = convertFullFilterToFilter(action.payload);
			state.modifiedFilter = convertedFilter;
		},
		setDateRange: (state, action: PayloadAction<DateRange>) => {
			state.modifiedFilter.dateFrom = action.payload.from;
			state.modifiedFilter.dateTo = action.payload.to;
		},
		setDistributionTypes: (state, action: PayloadAction<string[]>) => {
			state.modifiedFilter.distributionTypes = action.payload;
		},
		setOrderTypes: (state, action: PayloadAction<string[]>) => {
			state.modifiedFilter.orderTypes = action.payload;
		},
		setCountries: (state, action: PayloadAction<string[]>) => {
			state.modifiedFilter.countries = action.payload;
		},
		setRegions: (state, action: PayloadAction<string[]>) => {
			state.modifiedFilter.regions = action.payload;
		},
		setDistributionRegions: (state, action: PayloadAction<string[]>) => {
			state.modifiedFilter.distributionRegions = action.payload;
		},
		setDistricts: (state, action: PayloadAction<string[]>) => {
			state.modifiedFilter.districts = action.payload;
		},
		setDistributionDistricts: (state, action: PayloadAction<string[]>) => {
			state.modifiedFilter.distributionDistricts = action.payload;
		},
		setExecutionPlaces: (state, action: PayloadAction<string[]>) => {
			state.modifiedFilter.executionPlaces = action.payload;
		},
		setCustomerHierarchies: (state, action: PayloadAction<string[]>) => {
			state.modifiedFilter.customerHierarchies = action.payload;
		},
		setMaterialTypes: (state, action: PayloadAction<string[]>) => {
			state.modifiedFilter.materialTypes = action.payload;
		},
		setOnOffTrade: (state, action: PayloadAction<string[]>) => {
			state.modifiedFilter.onOffTrade = action.payload;
		},
		resetStore: (_) => initialState,
	},
});



export const {
	setFilter,
	resetFilter,
	clearFilter,
	fillFilter,
	setDateRange,
	setDistributionTypes,
	setOrderTypes,
	setCountries,
	setRegions,
	setDistributionRegions,
	setDistricts,
	setDistributionDistricts,
	setExecutionPlaces,
	setCustomerHierarchies,
	setMaterialTypes,
	setOnOffTrade,
	resetStore } = filterSlice.actions;